"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1654))
 * @lastsynced 2026-10-29T13:53:33.061Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Settings = createSVGIcon(
  <path
    d="m8.957 3.86.751-1.913A1.71 1.71 0 0 1 11.304.86h1.392a1.71 1.71 0 0 1 1.596 1.088l.75 1.914 2.487 1.436 2.031-.308a1.71 1.71 0 0 1 1.742.838l.696 1.2a1.71 1.71 0 0 1-.144 1.927l-1.283 1.613v2.87l1.283 1.606a1.715 1.715 0 0 1 .144 1.93l-.696 1.2a1.71 1.71 0 0 1-1.742.839l-2.031-.31-2.486 1.438-.751 1.913a1.715 1.715 0 0 1-1.596 1.088h-1.392a1.71 1.71 0 0 1-1.596-1.088l-.75-1.913-2.487-1.437-2.031.309a1.71 1.71 0 0 1-1.742-.839l-.696-1.2a1.715 1.715 0 0 1 .144-1.927l1.283-1.61v-2.87L2.146 8.962a1.71 1.71 0 0 1-.144-1.93l.696-1.2a1.71 1.71 0 0 1 1.742-.842l2.031.308zm-.386 8.142a3.429 3.429 0 1 0 6.858 0 3.429 3.429 0 0 0-6.858 0Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Settings",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "8+9vVH",
      defaultMessage: "Settings",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  })
);
